import React from 'react';

export default function AddTermModal({ showTermModal, closeTermModal, taxonomy, type, triggerRefresh, openMediaLibrary }) {
  const [termForm, setTermForm] = React.useState({ taxonomy: taxonomy || '', name: '', color: '#0000ff', image: '', type: type || 'select' });
  const [termSubmitting, setTermSubmitting] = React.useState(false);
  const [termSuccess, setTermSuccess] = React.useState(null);

  React.useEffect(() => {
    if (showTermModal) {
      const isColor = (type || 'select') === 'color';
      setTermForm({ taxonomy: taxonomy || '', name: '', color: isColor ? '#0000ff' : '#ffffff', image: '', type: type || 'select' });
      setTermSuccess(null);
    }
  }, [showTermModal, taxonomy, type]);

  const handleTermField = (k, v) => setTermForm((s) => ({ ...s, [k]: v }));

  const submitCreateTerm = async (e) => {
    e && e.preventDefault();
    setTermSubmitting(true);
    setTermSuccess(null);
    try {
      const form = new FormData();
      form.append('action', 'tpwvs_create_term');
      form.append('security', window.tpwvs_admin_settings.create_term_nonce || '');
      form.append('taxonomy', termForm.taxonomy);
      form.append('name', termForm.name);
      if (termForm.color) form.append('color', termForm.color);
      if (termForm.image) form.append('image', termForm.image);

      const res = await fetch(window.tpwvs_admin_settings.api_url, { method: 'POST', body: form });
      const json = await res.json();
      if (json && json.success) {
        setTermSuccess({ message: json.data && json.data.message ? json.data.message : 'Term created' });
        if (triggerRefresh) triggerRefresh();
      } else {
        setTermSuccess({ error: json && json.data && json.data.message ? json.data.message : 'Create failed' });
      }
    } catch (err) {
      setTermSuccess({ error: err.message || 'Network error' });
    } finally {
      setTermSubmitting(false);
    }
  };

  if (!showTermModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black opacity-40" onClick={closeTermModal} />
      <div className="bg-white rounded-lg shadow-lg z-50 w-full max-w-lg p-6">
        <h4 className="text-lg font-semibold mb-2">Add Term</h4>
        <p className="text-sm text-gray-700 mb-4">Add a new term for the attribute.</p>
        {termSuccess && termSuccess.message ? (
          <div className="mb-4">
            <div className="text-green-700">{termSuccess.message}</div>
            <div className="mt-3"><button onClick={closeTermModal} className="px-3 py-1 bg-indigo-600 text-white rounded">Close</button></div>
          </div>
        ) : (
          <form onSubmit={submitCreateTerm}>
            <div className="grid grid-cols-1 gap-3">
              <label className="block">
                <div className="text-sm font-semibold text-heading mb-1">Name</div>
                <input required value={termForm.name} onChange={(e) => handleTermField('name', e.target.value)} className="block w-full rounded-md border border-gray2 bg-white px-2 py-1 text-base text-gray-900 focus:outline-none focus:border-theme" />
              </label>

              {termForm.type === 'color' && (
                <label className="block">
                  <div className="text-sm font-semibold text-heading mb-1">Color</div>
                  <input
                    type="color"
                    value={termForm.color}
                    onChange={(e) => handleTermField('color', e.target.value)}
                    className="inline-block w-10 h-8 p-0 border border-gray2 rounded focus:outline-none"
                    style={{ display: 'inline-block', width: 40, height: 28, padding: 0 }}
                  />
                  <p className="text-sm text-gray-600 !m-0">Pick a color that will be used as the swatch.</p>
                </label>
              )}

              {termForm.type === 'image' && (
                <label className="block">
                  <div className="text-sm font-semibold text-heading mb-1">Image</div>
                  <div className="flex items-center gap-3">
                    <input readOnly value={termForm.image} placeholder="Image URL" className="block w-full rounded-md border border-gray2 bg-white px-2 py-1 text-sm text-gray-700 focus:outline-none focus:border-theme" />
                    <button type="button" onClick={() => openMediaLibrary((url) => handleTermField('image', url))} className="px-2 py-1 bg-gray-100 border rounded text-sm">Choose</button>
                  </div>
                  <p className="text-sm text-gray-600 !m-0">Upload or choose an image to display for this term.</p>
                </label>
              )}

              {termSuccess && termSuccess.error && (
                <div role="alert" className="mt-2 p-2 bg-red-50 border border-red-200 text-sm text-red-800 rounded-md">{termSuccess.error}</div>
              )}
            </div>
            <div className="mt-3 flex items-center gap-2">
              <button type="submit" disabled={termSubmitting} className="px-3 py-1.5 bg-theme text-white rounded text-sm">{termSubmitting ? 'Creating…' : 'Create Term'}</button>
              <button type="button" onClick={closeTermModal} className="px-2 py-1 border rounded text-sm">Cancel</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
